import { useQuery } from 'react-query';

import { useOrganizationApi } from './api';
import { organizationKeys } from '@config/queryKeys';

type Options = {
  organizationId?: string;
};
export default function useOrganizationStripeStatus({
  organizationId = '',
}: Options = {}) {
  const api = useOrganizationApi();
  const { data, isFetched, isFetching, isLoading, refetch } = useQuery(
    organizationKeys.stripeStatus(organizationId ?? ''),
    () => api.getStripeStatus(organizationId),
    {
      enabled: !!organizationId,
    }
  );

  return {
    isFetched,
    isFetching,
    isLoading,
    refetch,
    status: data,
  };
}
